import axios from '../axios'
import store from '../store/store'

export default class AttachmentService {

  async getAllOpportunityAttachments(oppId) {
    try {
      var path = '/v1/opportunityAttachments/' + oppId
      
      var response = await axios.get(path)
      // 
      return response.data
    } catch (err) {
      
    }
  }

  async getAllQuoteAttachments(id) {
    try {
      var path = '/v1/allquoteattachments/' + id
      
      var response = await axios.get(path)
      // 
      return response.data
    } catch (err) {
      
    }
  }

  async getAttachment(id) {
    try {
      var path = '/v1/attachment/' + id
      
      var response = await axios.get(path)
      // 
      return response.data
    } catch (err) {
      
    }
  }
  // async postAttachment(attachment) {
  //   try {
  //     var path = '/v1/attachment'
  //     
  //     var response = await axios.post(path, attachment)
  //     // 
  //     return response.data
  //   } catch (err) {
  //     
  //   }
  // }
  async putAttachment(id, attachment) {
    try {
      var path = '/v1/attachment/' + id
      
      var response = await axios.put(path, attachment)
      // 
      return response.data
    } catch (err) {
      
    }
  }
  async deleteAttachment(id) {
    try {
      var path = '/v1/attachment/' + id
      
      var response = await axios.delete(path)
      // 
      return response.data
    } catch (err) {
      throw err // C-S16: a failed delete must not look like a success
    }
  }
  postFile(file, obj) {
    return new Promise(async function(resolve, reject) {
      try {
        let formData = new FormData();
        formData.append('attachmentfile', file);
        formData.append('params', JSON.stringify(obj));

        var config = {
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            store.dispatch('setPercentageUploaded', Math.round(percentCompleted))
            if (percentCompleted === 100) {
              setTimeout(() => {
                store.dispatch('setUploading', false)
                store.dispatch('setPercentageUploaded', 0)
              }, 2000)
            }
          }
        };
        store.dispatch('setUploading', true)
        store.dispatch('setPercentageUploaded', 0)

        var path = '/v1/attachment/'
        
        var response = await axios.post(path, formData, config)
        resolve(response)

      } catch (err) {
        

        store.dispatch('setUploading', false)
        store.dispatch('setPercentageUploaded', 0)
        reject(err)
        
      }
    })
  }

  async fileDownloader(name) {
    // return new Promise((resolve, reject) => {
    try {
      var path = '/v1/downloadAttachment/' + name
      var config = { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user-token')}, 'responseType': 'blob' }
      var response = await axios.get(path, { responseType: 'blob' })
      
      const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] } )); //
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name); //or any other extension
      document.body.appendChild(link);
      link.click();

    } catch (err) {
      
    }
    // })
  }

  async fileDownloader1(name) {
    var config = {
      method: 'get',
      url: 'https://localhost:8444/adminserver/v1/downloadAttachment/abcd.pdf',
      headers: { 
        'Authorization': 'Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjQ4OTQ5ZDdkNDA3ZmVjOWIyYWM4ZDYzNWVjYmEwYjdhOTE0ZWQ4ZmIiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vbWJwLWNybSIsImF1ZCI6Im1icC1jcm0iLCJhdXRoX3RpbWUiOjE2MTU4Mjg1MzYsInVzZXJfaWQiOiJsVDh0Y2hnYlBoZklXQ2pocXVlUndPbjhlWDQyIiwic3ViIjoibFQ4dGNoZ2JQaGZJV0NqaHF1ZVJ3T244ZVg0MiIsImlhdCI6MTYxNTgyODUzNiwiZXhwIjoxNjE1ODMyMTM2LCJlbWFpbCI6Im1mc2h1c3NlaW5AZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsibWZzaHVzc2VpbkBnbWFpbC5jb20iXX0sInNpZ25faW5fcHJvdmlkZXIiOiJwYXNzd29yZCJ9fQ.jffIOPCBA9VunHUPjKjfzoAC8M88ANE2q1KWLjzonX5svaO8cb_K8iQCZw59RythQKorXqUy7v3EXiR1tHbWske6Vy0MBXqeDiZvi5NWvRyJAVtBuTScOeio2poV0gPG_QbibqwERbEMT6tgOpCqCBJb2Z0haMJ_PzsvXQa8K6HhzsMjEF9zQeoQVvnmV_LU0O2S1XTKpkSx8YLAjB26QlbG660gTNFM7R2au1JPA03NuVEZxWaB8mLNAYcuLTytheak2u5w1ppfBMsrek7grszPx8WCjvNkYXhJhNN9M47w_jQChXknKFS--HonL6nWaizghJIqLAkKg_AWMjbNpw'
      }
    };
    
    axios(config)
    .then(function (response) {
      
    })
    .catch(function (error) {
      
    });
   } 
}